import { useEffect, useState } from "react";
import { ANIMATION_TIME } from "../utils";

export const useMountWithTimer = (opened: boolean) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;

    if (opened && !mounted) {
      setMounted(true);
    } else if (!opened && mounted) {
      timer = setTimeout(() => {
        setMounted(false);
      }, ANIMATION_TIME);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [opened]);

  return mounted;
};
